<div class="container">
    <h1 style="text-align:center">Prenotazioni effettuate</h1>



    <app-credits [configApp]="app" *ngIf="app"></app-credits>


</div>